<template>
  <div ref="desktopMenu">
    <div
      class="DesktopMenu [@media(max-width:1024px)]:hidden w-full h-44
                bg-lightest text-darkest
                shadow-bottomLine
                sticky top-[53px] z-underHeader
                transition-transform duration-300
                select-none type-sm
                "
      :class="{
        '-translate-y-full': isScrolled && scrollPos > 44,
      }"
      role="navigation"
    >
      <div class="h-44 layout-container flex justify-between items-center">
        <div class="flex items-center justify-start">
          <div
            v-for="link in mainNavigation"
            :key="link._uid"
            class="desk:mr-12 deskStd:mr-20 last-of-type:mr-0"
          >
            <button
              v-if="link.children.length > 0"
              class="flex items-center h-[45px] border-b border-transparent hover:border-darkest transition-all duration-300 ease-out"
              :class="{
                'border-darkest text-text-base': uiStore.isParentOfOpenMenu(link._uid),
              }"
              type="button"
              aria-haspopup="true"
              :aria-expanded="uiStore.isParentOfOpenMenu(link._uid)"
              @click="clickMenuDesktop($sbLinkFix(link.link), (link.children.length > 0), link._uid, true)"
            >
              <span
                :class="{
                  'text-text-errorStrong hover:text-text-base': checkDesign(link.design, 'sale'),
                  'text-text-subtle hover:text-text-base': !checkDesign(link.design, 'sale'),
                }"
              >{{ link.title }}</span>
            </button>
            <nuxt-link
              v-else-if="$sbLinkCheck(link.link)"
              :to="$sbLinkFix(link.link)"
              :target="$sbLinkTarget(link.link)"
              class="flex items-center h-[45px] border-b border-transparent hover:border-darkest transition-all duration-300 ease-out"
              :class="{
                'text-text-errorStrong hover:text-text-base': checkDesign(link.design, 'sale'),
                'text-text-subtle hover:text-text-base': !checkDesign(link.design, 'sale'), }"
            >
              {{ link.title }}
            </nuxt-link>
          </div>
        </div>
        <div class="flex">
          <div
            v-for="link in secondaryNavigation"
            :key="link._uid"
            class="desk:mr-12 deskStd:mr-20 last-of-type:mr-0"
          >
            <button
              v-if="link.children.length > 0"
              class="flex items-center h-[45px] border-b border-transparent hover:border-darkest transition-all duration-300 ease-out"
              :class="{
                'border-darkest text-text-base': uiStore.isParentOfOpenMenu(link._uid),
              }"
              type="button"
              aria-haspopup="true"
              :aria-expanded="uiStore.isParentOfOpenMenu(link._uid)"
              @click="clickMenuDesktop($sbLinkFix(link.link), (link.children.length > 0), link._uid)"
            >
              <span
                :class="{
                  'text-text-errorStrong hover:text-text-base': checkDesign(link.design, 'sale'),
                  'text-text-subtle hover:text-text-base': !checkDesign(link.design, 'sale'),
                }"
              >{{ link.title }}</span>
            </button>
            <nuxt-link
              v-else-if="$sbLinkCheck(link.link)"
              :to="$sbLinkFix(link.link)"
              :target="$sbLinkTarget(link.link)"
              class="flex items-center h-[45px] border-b border-transparent hover:border-darkest transition-all duration-300 ease-out"
              :class="{
                'text-text-errorStrong hover:text-text-base': checkDesign(link.design, 'sale'),
                'text-text-subtle hover:text-text-base': !checkDesign(link.design, 'sale'),
              }"
            >
              {{ link.title }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>

    <div class="relative w-full">
      <DesktopMenuExpanded />

      <!-- hide prices -->
      <client-only>
        <div
          v-if="userStore.isLoggedIn && !userStore.isSamplesOnlyUser"
          class="relative w-full h-48 border-b border-border-subtle"
        >
          <div class="layout-container flex items-center h-48 gap-12 type-headline-sm">
            <div @click="uiStore.hidePrices = !uiStore.hidePrices">{{ $t('nav.sellerMode') }}</div>
            <TouchCheckbox :selected="uiStore.hidePrices ?? false" @set="e => uiStore.hidePrices = e"/>
          </div>
        </div>
      </client-only>
    </div>

  </div>
</template>

<script setup lang="ts">
import useCheckScroll from '~/composables/useCheckScroll';
import useMenuHelper from '~/composables/useMenuHelper';
import { onClickOutside } from '@vueuse/core';

import { useGlobalContentStore } from '~/store/globalContent';
import { useUiStore } from '~/store/ui';
import DesktopMenuExpanded from '~/components/menu/DesktopMenuExpanded.vue';
import { useUserStore } from '~/store/user';
import TouchCheckbox from '~/components/form-elements/TouchCheckbox.vue';

const globalContent = useGlobalContentStore();
const mainNavigation = globalContent.getNavigation('mainNavigation');
const secondaryNavigation = globalContent.getNavigation('secondaryNavigation');
const uiStore = useUiStore();
const userStore = useUserStore();

const { isScrolled, scrollPos } = useCheckScroll();
const { checkDesign, clickMenuDesktop } = useMenuHelper();

const desktopMenu = ref<HTMLElement>();

onClickOutside(desktopMenu, () => {
  uiStore.closeDesktopMenu();
});

</script>
